/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import moment from "moment-timezone";

const TriDurationConstants = {
  Multiplier: {
    SECOND: 1000,
    get MINUTE() {
      return 60 * this.SECOND;
    },
    get HOUR() {
      return 60 * this.MINUTE;
    },
    get DAY() {
      return 24 * this.HOUR;
    },
    get WEEK() {
      return 7 * this.DAY;
    },
    MONTH: 100000000000000,
  },
};

export function convertTririgaDurationToIso(durationParam) {
  if (durationParam == null || isNaN(durationParam)) return null;
  let tririgaDuration = Number(durationParam);
  if (tririgaDuration < 0) {
    tririgaDuration = Math.abs(tririgaDuration);
  }

  const durationObj = {
    milliseconds: 0,
    seconds: 0,
    minutes: 0,
    hours: 0,
    days: 0,
    months: 0,
    years: 0,
  };

  const totalMonths = Math.floor(
    tririgaDuration / TriDurationConstants.Multiplier.MONTH
  );
  tririgaDuration = tririgaDuration % TriDurationConstants.Multiplier.MONTH;
  durationObj.years = Math.floor(totalMonths / 12);
  durationObj.months = totalMonths % 12;

  durationObj.days = Math.floor(
    tririgaDuration / TriDurationConstants.Multiplier.DAY
  );
  tririgaDuration = tririgaDuration % TriDurationConstants.Multiplier.DAY;

  durationObj.hours = Math.floor(
    tririgaDuration / TriDurationConstants.Multiplier.HOUR
  );
  tririgaDuration = tririgaDuration % TriDurationConstants.Multiplier.HOUR;

  durationObj.minutes = Math.floor(
    tririgaDuration / TriDurationConstants.Multiplier.MINUTE
  );
  tririgaDuration = tririgaDuration % TriDurationConstants.Multiplier.MINUTE;

  durationObj.seconds = Math.floor(
    tririgaDuration / TriDurationConstants.Multiplier.SECOND
  );
  tririgaDuration = tririgaDuration % TriDurationConstants.Multiplier.SECOND;

  durationObj.milliseconds = tririgaDuration;
  return moment.duration(durationObj).toISOString();
}
